import { FC, useContext, useEffect, useState } from "react";

import appStyles from "../../../App.module.css";
import { formatDate } from "../../../app-constants";
import amtConstants, { clearConectiaReqId } from "../../config/amt-constants";
import { ISingleTripQuoteContext, SingleTripQuoteContext } from "../TripQuote";
import Footer from "../common/Footer";
import OrderSummary from "../common/OrderSummary";
import ForwardArrow from "../icons/ForwardArrow";

interface OrderDetailProps {}

const OrderDetail: FC<OrderDetailProps> = (props: OrderDetailProps) => {
  const { order, restart, quoteData } = useContext(SingleTripQuoteContext) as ISingleTripQuoteContext;

  const [conectiaPixelLink, setConectiaPixelLink] = useState<string | null>(null);

  useEffect(() => {
    // sending tracking event for conectia
    if (quoteData.affiliate_id == amtConstants.conectiaPartnerId && quoteData.conectia_req_id?.length) {
      const queryData = {
        r: quoteData.conectia_req_id,
        t: `${order.order_number}`,
        p: `${order?.total || 0}`,
        o: "1598",
        e: "1193",
        f: "pb",
      };
      const query = new URLSearchParams(queryData);
      const queryString = query.toString();
      setConectiaPixelLink(`https://mywebconect.com/p.ashx?${queryString}`);
      clearConectiaReqId();
    }
  }, []);
  return (
    <div className={`${appStyles.mainContainer} ${appStyles.W600}`}>
      <div className={`${appStyles.quotePaymentWrapper}`}>
        <div className={`${appStyles.headerWrapper}`}>
          <div className={`${appStyles.pageTitle} ${appStyles.pageTitleCongrats}`}>
            <h1 className={`${appStyles.colorSuccess}`}>
              Congratulations! <br />
              You’re covered
            </h1>
          </div>
        </div>
        <div className={`${appStyles.pageTitle} ${appStyles.pageTitleCongrats}`}>
          <p>Check your inbox for an email with your policy documents and related information.</p>
        </div>
        <div className={`${appStyles.tripSummaryRow} ${appStyles.tripSummaryRowOrderInfo}`}>
          <div className={appStyles.tripSummaryLabel}>Order No: {order?.order_number}</div>
          <div className={appStyles.tripSummaryLabel}>Order Date: {formatDate(new Date(order?.ordered_at))}</div>
        </div>
        <OrderSummary />
        <div className={`${appStyles.pageSubTitle} ${appStyles.bfMarginTop}`}>
          <h2 className={appStyles.colorPrimary}>Your policy</h2>
        </div>
        <div className={`${appStyles.quoteFormBlock} ${appStyles.quoteFormPolicyInformation}`}>
          <div className={`${appStyles.tripSummaryRow}`}>
            <div className={`${appStyles.tripPolicyInfo}`}>
              <b className={`${appStyles.tripPolicyPerson}`}>
                {`${order?.applicant?.first_name || ""} ${order?.applicant?.middle_name || ""} ${
                  order?.applicant?.last_name
                }` || ""}
              </b>
              <span className={appStyles.tripSummaryLabel}>Policy #</span>
              <b>{order?.items[0]?.policy_number}</b>
            </div>
          </div>
        </div>
        <Footer />
        <div className={appStyles.formRow}>
          <div
            className={`${appStyles.buttonBlock} ${appStyles.buttonBlockNextPrev} ${appStyles.buttonBlockAlignCenter}`}
          >
            <button
              className={`${appStyles.bfButton} ${appStyles.bfbuttonHasIcon} ${appStyles.bfbuttonIconAfter} ${appStyles.bfButtonOutline}`}
              type="button"
              onClick={(e) => {
                restart();
              }}
            >
              New Quote
              <span className={`${appStyles.bfButtonIcon} ${appStyles.bfButtonIconNext}`}>
                <ForwardArrow />
              </span>
            </button>
          </div>
        </div>
      </div>
      {conectiaPixelLink ? <img src={conectiaPixelLink} width="1" height="1" style={{ border: 0 }} /> : ""}
    </div>
  );
};

export default OrderDetail;
